import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Reveal, Chapter } from "@/components/Reveal";

const FAQS = [
  {
    q: "How long does an inspection take?",
    a: "Usually 60–90 minutes, depending on the vehicle and the type of inspection.",
    slug: "duration",
  },
  {
    q: "Do you inspect new cars?",
    a: "Yes. We provide a complete Pre-Delivery Inspection (PDI) before you take delivery, so hidden manufacturing defects don't become your problem.",
    slug: "new-cars",
  },
  {
    q: "Do you inspect used cars?",
    a: "Yes. Our used car inspection is a complete health check covering mechanical, electrical, body and accident history.",
    slug: "used-cars",
  },
  {
    q: "Do I receive a report?",
    a: "Yes. A detailed digital PDF report is provided with photos, findings, paint thickness readings and OBD fault codes.",
    slug: "report",
  },
  {
    q: "Do you travel?",
    a: "Yes, we provide on-site inspections across Hyderabad — at the dealer, the seller's location, or your home.",
    slug: "travel",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-28 md:py-36">
    <div className="mx-auto max-w-3xl px-5 md:px-8">
      <Reveal>
        <Chapter index="08" label="FAQ" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 font-heading text-4xl font-extrabold tracking-tight text-white md:text-5xl">
          Questions, answered.
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.slug}
              value={f.slug}
              className="border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${f.slug}`}
                className="py-6 font-heading text-base font-bold text-white transition-colors duration-300 hover:text-gold hover:no-underline md:text-lg"
              >
                <span className="flex items-center gap-4">
                  <span className="text-xs font-extrabold tracking-[0.2em] text-gold/60">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${f.slug}`}
                className="pb-6 pl-10 text-sm leading-relaxed text-white/55 md:text-base"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
